import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/core.state';
import { CongressionalDistrict } from '../../models/congressional-district';
import { combineLatest, debounceTime, filter, Subject, take, takeUntil } from 'rxjs';
import { selectLoading, selectScorecards, selectSelectedCongressionalDistricts, selectSelectedCongressman, selectSelectedLocalUnion, selectStates } from '../../store/core.selector';
import { ScoreCard } from '../../models/score-card.enum';
import { DataType } from '../../models/lookups';
import { clearStore, getScorecard } from '../../store/core.actions';
import { ScorecardView } from '../../models/views';
import { Router, RouterLink } from '@angular/router';
import { ScoreCardComponent } from '../score-card/score-card.component';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-score-card-page',
    templateUrl: './score-card-page.component.html',
    styleUrls: ['./score-card-page.component.scss'],
    imports: [MatButton, RouterLink, NgClass, ScoreCardComponent]
})

export class ScoreCardPageComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<void> = new Subject();
  @Input() scoreCardType: ScoreCard;
  ScoreCard = ScoreCard;
  selectedCongressman: DataType;
  selectedLocalUnion: number | null;
  scoreCards: ScorecardView[]
  
  selectedCongressionalDistricts: CongressionalDistrict[];
  states: DataType[];
  
  constructor(private store: Store<AppState>, private router: Router) { }

  ngOnInit() {
  const nav = history.state;
  if (nav?.scoreCardType) this.scoreCardType = nav.scoreCardType as ScoreCard;

  combineLatest([
    this.store.pipe(select(selectSelectedCongressman)),
    this.store.pipe(select(selectSelectedCongressionalDistricts)),
    this.store.pipe(select(selectSelectedLocalUnion)),
    this.store.pipe(select(selectLoading))
  ]).pipe(filter(([congressman, districts, localUnion, loading]) => !loading), take(1))
  .subscribe(([congressman, districts, localUnion]) => {

    const hasCongressmanOrDistrict = !!congressman || (districts && districts.length > 0);

    const hasLocalUnion = !!localUnion && localUnion !== 0;

    if (!hasCongressmanOrDistrict && !hasLocalUnion)
      this.router.navigate(['/']);
  });

  this.store.pipe(select(selectSelectedCongressman), takeUntil(this.unsubscribe$), filter(c => !!c))
    .subscribe(c => {
      this.selectedCongressman = c!;
      this.store.dispatch(getScorecard({ congressmanId: c!.id }));
  });

  this.store.pipe(select(selectSelectedLocalUnion), takeUntil(this.unsubscribe$)).subscribe(lu => {
    if (lu && lu !== 0) { 
      this.selectedLocalUnion = lu;
      this.store.dispatch(getScorecard({ localUnion: this.selectedLocalUnion }));
    }
  });

  this.store.pipe(select(selectScorecards), takeUntil(this.unsubscribe$), filter(s => !!s && s.length > 0))
    .subscribe(s => this.scoreCards = s);

  this.store.pipe(select(selectSelectedCongressionalDistricts), takeUntil(this.unsubscribe$))
    .subscribe(sd => {
      this.selectedCongressionalDistricts = sd;
      if (sd && sd.length > 0)
        this.store.dispatch(getScorecard({ stateId: sd[0].stateId, districtNumber: sd[0].districtNumber }));
    });

  this.store.pipe(select(selectStates), takeUntil(this.unsubscribe$)).subscribe(s => this.states = s);
}

  ngOnDestroy() {
    this.store.dispatch(clearStore());
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}